<template>
  <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-row class="no-gutters">
      <v-col cols="12" sm="6" md="6" lg="3">
        <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search here ..." single-line solo
          hide-details></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="2">
        <v-select solo :items="slots" append-icon="mdi-chevron-down" label="All Accounts"
          class="custom-select"></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="3">
        <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" width="290px" class="">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="dateRangeText" prepend-icon="mdi-calendar" append-icon="mdi-chevron-down" readonly
              v-bind="attrs" v-on="on" solo class="custom-select"></v-text-field>
          </template>
          <v-date-picker v-model="date" class="custom-date-picker" scrollable range>
            <v-spacer></v-spacer>
            <v-btn :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'" text @click="modal = false"> Cancel </v-btn>
            <v-btn :color="$vuetify.theme.dark ? '#fff' : '#131c29'" text @click="$refs.dialog.save(date)">
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="4">
        <ul>
          <li>
            <span>Total Equity:</span>
            <span>129050</span>
          </li>
          <li>
            <span>Total Lot:</span>
            <span>12.90</span>
          </li>
          <li>
            <span class="profit-loss">Profit / Loss:</span>
            <span>-20000</span>
          </li>
        </ul>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12">
        <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
          <v-sheet class="transactionTable liveTradeTable pb-3" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
            <v-data-table :headers="headers" :items="desserts" :search="search" :items-per-page="6">
              <template v-slot:item.detail="{ item }">
                <router-link class="links text-decoration-none" to="/">
                  <v-icon small>
                    {{ item.detail }}
                  </v-icon>
                </router-link>
              </template>
              <template v-slot:item.profit="{ item }">
                <span class="profit-text-color">
                  {{ item.profit }}
                </span>
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" xl="12">
        <MiddleBar></MiddleBar>
      </v-col>
    </v-row>
    <LiveAccounts></LiveAccounts>
  </v-card>
</template>
<script>
import LiveAccounts from './LiveAccounts.vue';
import MiddleBar from './MiddleBar.vue';
export default {
  components: { MiddleBar, LiveAccounts },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Date & Time",
          align: "start",
          value: "dataTimes",
        },
        { text: "Acc. No.", value: "accountNumber" },
        { text: "Ticket", value: "ticketNumber" },
        { text: "Acc. Type", value: "accountType" },
        { text: "Lots", value: "lots" },
        { text: "Symbol", value: "symbol" },
        { text: "Open", value: "open" },
        { text: "SL-TP", value: "sltp" },
        { text: "Running", value: "running" },
        { text: "Comm.", value: "common" },
        { text: "Equity", value: "equity" },
        { text: "Profit", value: "profit" },
        { text: "Detail", value: "detail" },
      ],
      desserts: [
        {
          dataTimes: "25.08.2020-8:32 pm",
          accountNumber: "2132 (test)",
          ticketNumber: 120,
          accountType: "Gold",
          lots: "1:656",
          symbol: "$",
          open: "$656",
          sltp: ".10-.20",
          running: "$656",
          common: "10%",
          equity: "$12030",
          profit: "$30",
          detail: "mdi-eye-outline",
        },
        {
          dataTimes: "25.08.2020-8:32 pm",
          accountNumber: "2132 (test)",
          ticketNumber: 120,
          accountType: "Gold",
          lots: "1:656",
          symbol: "$",
          open: "$656",
          sltp: ".10-.20",
          running: "$656",
          common: "10%",
          equity: "$12030",
          profit: "$30",
          detail: "mdi-eye-outline",
        },
        {
          dataTimes: "25.08.2020-8:32 pm",
          accountNumber: "2132 (test)",
          ticketNumber: 120,
          accountType: "Gold",
          lots: "1:656",
          symbol: "$",
          open: "$656",
          sltp: ".10-.20",
          running: "$656",
          common: "10%",
          equity: "$12030",
          profit: "$30",
          detail: "mdi-eye-outline",
        },
        {
          dataTimes: "25.08.2020-8:32 pm",
          accountNumber: "2132 (test)",
          ticketNumber: 120,
          accountType: "Gold",
          lots: "1:656",
          symbol: "$",
          open: "$656",
          sltp: ".10-.20",
          running: "$656",
          common: "10%",
          equity: "$12030",
          profit: "$30",
          detail: "mdi-eye-outline",
        },
        {
          dataTimes: "25.08.2020-8:32 pm",
          accountNumber: "2132 (test)",
          ticketNumber: 120,
          accountType: "Gold",
          lots: "1:656",
          symbol: "$",
          open: "$656",
          sltp: ".10-.20",
          running: "$656",
          common: "10%",
          equity: "$12030",
          profit: "$30",
          detail: "mdi-eye-outline",
        },
        {
          dataTimes: "25.08.2020-8:32 pm",
          accountNumber: "2132 (test)",
          ticketNumber: 120,
          accountType: "Gold",
          lots: "1:656",
          symbol: "$",
          open: "$656",
          sltp: ".10-.20",
          running: "$656",
          common: "10%",
          equity: "$12030",
          profit: "$30",
          detail: "mdi-eye-outline",
        },
        {
          dataTimes: "25.08.2020-8:32 pm",
          accountNumber: "2132 (test)",
          ticketNumber: 120,
          accountType: "Gold",
          lots: "1:656",
          symbol: "$",
          open: "$656",
          sltp: ".10-.20",
          running: "$656",
          common: "10%",
          equity: "$12030",
          profit: "$30",
          detail: "mdi-eye-outline",
        },
        {
          dataTimes: "25.08.2020-8:32 pm",
          accountNumber: "2132 (test)",
          ticketNumber: 120,
          accountType: "Gold",
          lots: "1:656",
          symbol: "$",
          open: "$656",
          sltp: ".10-.20",
          running: "$656",
          common: "10%",
          equity: "$12030",
          profit: "$30",
          detail: "mdi-eye-outline",
        },
        {
          dataTimes: "25.08.2020-8:32 pm",
          accountNumber: "2132 (test)",
          ticketNumber: 120,
          accountType: "Gold",
          lots: "1:656",
          symbol: "$",
          open: "$656",
          sltp: ".10-.20",
          running: "$656",
          common: "10%",
          equity: "$12030",
          profit: "$30",
          detail: "mdi-eye-outline",
        },
        {
          dataTimes: "25.08.2020-8:32 pm",
          accountNumber: "2132 (test)",
          ticketNumber: 120,
          accountType: "Gold",
          lots: "1:656",
          symbol: "$",
          open: "$656",
          sltp: ".10-.20",
          running: "$656",
          common: "10%",
          equity: "$12030",
          profit: "$30",
          detail: "mdi-eye-outline",
        },
      ],
      slots: ["7656001492(MICRO)", "7656006392(MICRO)", "7102006392(MICRO)"],
      date: ["2022-01-01", this.getCurrentDate()],
      modal: false,
    };
  },
  computed: {
    dateRangeText() {
      return this.date.join(" ~ ");
    },
  },
  methods: {
    getCurrentDate() {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split('T')[0];
      return formattedDate;
    },
  },
};
</script>
